import { createSelector } from 'reselect'
import sortedLayoutsSelector from '../selectors/sortedLayouts'

export default createSelector(
  [
    sortedLayoutsSelector,
  ],
  (
    layouts,
  ) => ({
    layouts,
    layoutIds: layouts.map(layout => layout.id),
  })
)
